import React from "react";

import { Dropdown } from "@fluentui/react";
import { useTheme } from "styled-components";
import { IStyledTheme } from "theme/types";

type FleetCountryOption = {
  text: string;
  key: string;
};

type Props = {
  value: string | null;
  onChange?: (value: FleetCountryOption | null) => void;
  options: any[];
  isClearable?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  isOptionDisabled?: (o: FleetCountryOption) => boolean;
  portalTarget?: any;
};

export const FleetCountrySelect = ({
  value,
  onChange,
  options,
  isClearable,
  isLoading,
  isDisabled,
  isOptionDisabled,
  portalTarget,
}: Props) => {
  const theme = useTheme() as IStyledTheme;

  return (
    <>
      <Dropdown
        style={{
          minWidth: 170,
        }}
        styles={{
          root: {
            "& .ms-Dropdown-title": {
              borderColor: theme.palette.neutralTertiaryAlt,
            },
          },
        }}
        onChange={(_, option) => {
          onChange && onChange(option as any);
        }}
        placeholder={""}
        label=""
        options={options}
        selectedKey={value}
        disabled={isDisabled}
      />
    </>
  );
};
